class TextEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    const getRandomInt = (min, max) => {
      return Math.floor(Math.random() * (max - min) + min);
    }

    const ScrollAnimation = {
      instance: undefined,
      set() {
        this.instance = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if(entry.isIntersecting) {
                entry.target.classList.add('is-active');
              }
            });
          },
          {
            root: null,
            rootMargin: '0px',
            threshold: 0,
          }
        );

        const blocks = document.querySelectorAll('.title');
        blocks.forEach((block) => {
          this.instance.observe(block);
        });
      },
    };

    const SplitText = (target) => {
      const splitElm = document.querySelectorAll(target);
      splitElm.forEach((el, index) => {
        let text = el.textContent;
        el.textContent = '';
        text = text.split('');
        let newText = '';
        text.forEach((t, index) => {
          newText += `<span class="word" data-random="${getRandomInt(1, 8)}">${t}</span>`;
        });
        el.insertAdjacentHTML('beforeend', newText);
      });
    };

    SplitText('.text-split');
    ScrollAnimation.set();


    
  }
}
